const views = [{
    path: '/routes',
    name: 'routes',
    component: resolve => require(["@/components/routes"],resolve),
    meta: {
        name: '路由查看页',
    }
  }];
const error = [{
    path: '*',
    name: '重定向',
    redirect: '/home',
    meta: {
        name: '慢病管理',
    }
}]

const homes = [{
    path: '/home',
    name: 'home',
    component: resolve => require(["@/components/index"],resolve),
    meta: {
        name: '慢病管理',
	    tabbars: 0,
	    keepAlive: true
    }
}];
const call = [{
    path: '/call/chat',
    name: 'callchat',
    component: resolve => require(["@/components/call/chat"],resolve),
    meta: {
        name: ''
    }
},{
    path: '/call/groupchat',
    name: 'callgroupchat',
    component: resolve => require(["@/components/call/groupchat"],resolve),
    meta: {
        name: ''
    }
},];
const news = [{
    path: '/news/newslist',
    name: 'newslist',
    component: resolve => require(["@/components/news/newslist"], resolve),
    meta: {
        name: '健康科普',
    }
}, {
    path: '/news/detail',
    name: 'newsdetail',
    component: resolve => require(["@/components/news/detail"], resolve),
    meta: {
        name: '资讯详情',
    }
}, {
    path: '/news/messagelist',
    name: 'messagelist',
    component: resolve => require(["@/components/news/messagelist"], resolve),
    meta: {
        name: '消息',
    }
},
];

const user = [{
	    path: '/user/privacy',
	    name: 'privacy',
	    component: resolve => require(["@/components/user/privacy"],resolve),
	    meta: {
	        name: '隐私政策',
	    }
	},{
	    path: '/user/newprivacy',
	    name: 'newprivacy',
	    component: resolve => require(["@/components/user/newprivacy"],resolve),
	    meta: {
	        name: '隐私政策',
	    }
	},{
	    path: '/user/login',
	    name: 'login',
	    component: resolve => require(["@/components/user/login"],resolve),
	    meta: {
	        name: '登录',
	    }
	},{
	    path: '/user/register',
	    name: '新用户注册',
	    component: resolve => require(["@/components/user/register"],resolve),
	    meta: {
	        name: '新用户注册',
	    }
	},{
	    path: '/user/repwd',
	    name: 'repwd',
	    component: resolve => require(["@/components/user/repwd"],resolve),
	    meta: {
	        name: '找回密码',
	    }
	},{
	    path: '/user/agreement',
	    name: '用户协议',
	    component: resolve => require(["@/components/user/agreement"],resolve),
	    meta: {
	        name: '用户协议',
	    }
	},{
	    path: '/user/newagreement',
	    name: 'newagreement',
	    component: resolve => require(["@/components/user/newagreement"],resolve),
	    meta: {
	        name: '用户协议',
	    }
	},{
	    path: '/user/index',
	    name: '我的',
	    component: resolve => require(["@/components/user/index"],resolve),
	    meta: {
	        name: '我的',
	        tabbars: 2
	    }
	},{
	    path: '/user/set',
	    name: '设置',
	    component: resolve => require(["@/components/user/set"],resolve),
	    meta: {
	        name: '设置',
	    }
	},{
	    path: '/user/info',
	    name: '编辑资料',
	    component: resolve => require(["@/components/user/info"],resolve),
	    meta: {
	        name: '编辑资料',
	    }
	},{
	    path: '/user/uppwd',
	    name: '修改密码',
	    component: resolve => require(["@/components/user/uppwd"],resolve),
	    meta: {
	        name: '修改密码',
	    }
	},{
	    path: '/user/aboutus',
	    name: '关于慢病管理',
	    component: resolve => require(["@/components/user/aboutus"],resolve),
	    meta: {
	        name: '关于慢病管理',
	    }
	},{
	    path: '/user/myfocus',
	    name: 'myfocus',
	    component: resolve => require(["@/components/user/myfocus"],resolve),
	    meta: {
	        name: '我的关注',
	    	keepAlive: true
	    }
	},{
	    path: '/user/attend',
	    name: 'attend',
	    component: resolve => require(["@/components/user/attend"],resolve),
	    meta: {
	        name: '亲友旁听',
	    }
	},{
	    path: '/user/service',
	    name: 'service',
	    component: resolve => require(["@/components/user/service"],resolve),
	    meta: {
	        name: '在线客服',
	    }
	},{
	    path: '/user/coup',
	    name: 'coup',
	    component: resolve => require(["@/components/user/coup"],resolve),
	    meta: {
	        name: '积分流水',
	    }
	},{
	    path: '/user/addcoup',
	    name: 'addcoup',
	    component: resolve => require(["@/components/user/addcoup"],resolve),
	    meta: {
	        name: '积分充值',
	    }
	},{
	    path: '/user/doctorservice',
	    name: 'doctorservice',
	    component: resolve => require(["@/components/user/doctorservice"],resolve),
	    meta: {
	        name: '我的医生',
	    }
	},{
	    path: '/user/addcase',
	    name: 'addcase',
	    component: resolve => require(["@/components/user/addcase"],resolve),
	    meta: {
	        name: '编辑档案',
	    }
	},
];
const order=[
	{
	    path: '/order/list',
	    name: 'list',
	    component: resolve => require(["@/components/order/list"],resolve),
	    meta: {
	        name: '我的预约',
	        tabbars: 1
	    }
	},{
	    path: '/order/orderdetail',
	    name: 'orderdetail',
	    component: resolve => require(["@/components/order/orderdetail"],resolve),
	    meta: {
	        name: '预约详情'
	    }
	},{
	    path: '/order/cases',
	    name: 'cases',
	    component: resolve => require(["@/components/order/cases"],resolve),
	    meta: {
	        name: '健康档案'
	    }
	},{
	    path: '/order/casesdetail',
	    name: 'casesdetail',
	    component: resolve => require(["@/components/order/casesdetail"],resolve),
	    meta: {
	        name: '档案详情'
	    }
	},{
	    path: '/order/becall',
	    name: 'becall',
	    component: resolve => require(["@/components/order/becall"],resolve),
	    meta: {
	        name: ''
	    }
	},{
	    path: '/order/service',
	    name: 'serviceorder',
	    component: resolve => require(["@/components/order/service"],resolve),
	    meta: {
	        name: '服务订单'
	    }
	}
	
]
const login=[
	{
	    path: '/login/down',
	    name: 'down',
	    component: resolve => require(["@/components/login/down"],resolve),
	    meta: {
	        name: 'APP下载'
	    }
	},
]
const doctor=[
	{
	    path: '/doctor/video',
	    name: 'doctorvideo',
	    component: resolve => require(["@/components/doctor/video"],resolve),
	    meta: {
	        name: '',
	    }
	},{
	    path: '/doctor/list',
	    name: '问问专家更放心',
	    component: resolve => require(["@/components/doctor/list"],resolve),
	    meta: {
	        name: '问问专家更放心',
	        keepAlive: true
	    }
	},{
	    path: '/doctor/comment',
	    name: '用户评论',
	    component: resolve => require(["@/components/doctor/comment"],resolve),
	    meta: {
	        name: '用户评论'
	    }
	},{
	    path: '/doctor/detail',
	    name: '专家信息',
	    component: resolve => require(["@/components/doctor/detail"],resolve),
	    meta: {
	        name: '专家信息'
	    }
	},{
	    path: '/doctor/chosetime',
	    name: '选择时间',
	    component: resolve => require(["@/components/doctor/chosetime"],resolve),
	    meta: {
	        name: '选择时间'
	    }
	},{
	    path: '/doctor/medicalrecords',
	    name: '病例填写',
	    component: resolve => require(["@/components/doctor/medicalrecords"],resolve),
	    meta: {
	        name: '病例填写'
	    }
	},{
	    path: '/doctor/mesagechat',
	    name: 'mesagechat',
	    component: resolve => require(["@/components/doctor/mesagechat"],resolve),
	    meta: {
	        name: '病友群'
	    }
	},{
	    path: '/doctor/mesagechata',
	    name: 'mesagechata',
	    component: resolve => require(["@/components/doctor/mesagechata"],resolve),
	    meta: {
	        name: '病友群'
	    }
	},{
	    path: '/doctor/mydoctor',
	    name: 'mydoctor',
	    component: resolve => require(["@/components/doctor/mydoctor"],resolve),
	    meta: {
	        name: '我的咨询'
	    }
	},{
	    path: '/doctor/editgroup',
	    name: 'editgroup',
	    component: resolve => require(["@/components/doctor/editgroup"],resolve),
	    meta: {
	        name: '病友群'
	    }
	},{
	    path: '/doctor/userchat',
	    name: 'userchat',
	    component: resolve => require(["@/components/doctor/userchat"],resolve),
	    meta: {
	        name: '聊天'
	    }
	},{
	    path: '/doctor/userchata',
	    name: 'userchata',
	    component: resolve => require(["@/components/doctor/userchata"],resolve),
	    meta: {
	        name: '聊天'
	    }
	},{
	    path: '/doctor/team',
	    name: 'team',
	    component: resolve => require(["@/components/doctor/team"],resolve),
	    meta: {
	        name: '专家团队'
	    }
	},
	
	
]
export const routes = [...call,...login,...views,...error, ...homes, ...user,...news,...order,...doctor];


// WEBPACK FOOTER //
// ./src/router/module/index.js